import {Directive, ElementRef} from '@angular/core';
import {PopoverController} from "ionic-angular";
import {SettingsPopoverPage} from "../../pages/settings-popover/settings-popover";

/**
 * Generated class for the SettingsPopoverDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[settings-popover]' // Attribute selector
})
export class SettingsPopoverDirective {

  openedPopover: any;

  constructor(public popoverCtrl: PopoverController, public element:ElementRef) {

  }

  ngAfterViewInit() {
    var me = this;
    this.element.nativeElement.addEventListener('click', function ($event) {
      me.showPopover($event);
    })
  }

  showPopover($event) {
    if(this.openedPopover) {
      this.openedPopover.dismiss();
      return ;
    }

    this.openedPopover = this.popoverCtrl.create(
      SettingsPopoverPage,
      {popoverObject: this},
      {cssClass: 'settings-popover'}
    );
    this.openedPopover.present({
      ev: $event,
    });

    this.openedPopover.onDidDismiss(() => {
      this.openedPopover = null;
    });
  }

  dismissPopup() {
    if(this.openedPopover) {
      this.openedPopover.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/settings-popover/settings-popover.ts